import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTabsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-end;
`;

export const StyledCreateButton = styled(Button)`
  &&& {
    max-width: 13rem;
    height: 2.125rem;

    svg {
      fill: ${COLORS.BLACK};
    }
  }
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 2rem;
  background: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;
